import { State } from "../types/BaseContext.types";

const constructFileName = () => {
  const formattedDate = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const dateParts: any = {};
  formattedDate.formatToParts(new Date()).forEach(({ type, value }) => {
    dateParts[type] = value;
  });

  return `treatcheck_settings_${dateParts.year}-${dateParts.month}-${dateParts.day}_${dateParts.hour}-${dateParts.minute}.threatcheck`;
};

const requestAndDownloadBundle = async (baseState: State) => {
  const encryptedProgressFile = await fetch("/api/v1/bundle/create", {
    method: "POST",
    body: JSON.stringify(baseState),
    headers: {
      "Content-Type": "application/json",
    },
  });

  const url = window.URL.createObjectURL(await encryptedProgressFile.blob());
  const a = document.createElement("a");
  a.href = url;
  a.download = constructFileName();
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export default requestAndDownloadBundle;
